// Privacy-safe product analytics. Fire-and-forget POST to
// /analytics/event; never throws, never blocks, and carries no private
// content or credentials - only an event name plus whitelisted ids.
const API_BASE = import.meta.env.VITE_AUTH_API_BASE ?? '/api-auth';

export type AnalyticsEvent =
  | 'explore_viewed'
  | 'public_channel_viewed'
  | 'follow_clicked'
  | 'follow_completed'
  | 'create_similar_clicked'
  | 'channel_shared'
  | 'ask_started'
  | 'ask_answered'
  | 'ask_failed'
  | 'webmcp_tool_invoked'
  | 'webmcp_tool_failed';

export interface AnalyticsProps {
  origin_channel_id?: string;
  template_id?: string;
}

export function buildEventBody(event: AnalyticsEvent, props: AnalyticsProps = {}): Record<string, string> {
  const body: Record<string, string> = { event };
  if (props.origin_channel_id) body.origin_channel_id = String(props.origin_channel_id).slice(0, 128);
  if (props.template_id) body.template_id = String(props.template_id).slice(0, 128);
  return body;
}

export function track(event: AnalyticsEvent, props: AnalyticsProps = {}): void {
  try {
    void fetch(`${API_BASE}/analytics/event`, {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildEventBody(event, props)),
    }).catch(() => {});
  } catch {
    // analytics must never affect the app
  }
}
